import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchGebiedswissels,
} from '../services/searchGebiedswissels'

import { useGebiedswisselsSearchStore } from './useGebiedswisselsSearchStore'

export { useGebiedswisselsSearch, queryKey }

const queryKey = 'gebiedswissels'

const useQueryStore = () => {
  const { query, storeQuery } = useGebiedswisselsSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useGebiedswisselsSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchGebiedswissels({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    sort: query.sort,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
